import { from as from$, of as of$ } from 'rxjs';

import CommentService from '../../../services/comment.service';
import { requestId } from './request.helper';
import { COMMENTS } from '../../../enums';

export const updateComments = (store, payload, commentType = COMMENTS.TYPES.REQUEST) => {
  const currentComments = payload || store.value.infobox.notes;
  if (!currentComments || currentComments.length === 0) {
    return of$(null);
  }
  return from$(CommentService.create(requestId(store), currentComments, commentType));
};

export const getComment = id => from$(CommentService.getComment(id));
